import React from "react";
import { node, string } from "prop-types";
import { classes } from "../utils/classes";

const ModalHead = ({ className = "", children = "" }) => {
	return <div className={classes("modal__header", className)}>{children}</div>;
};

ModalHead.propTypes = {
	className: string,
	children: node,
};

export default ModalHead;
